import React, { Component } from "react";
import { dateConvert } from "../../common/Helpers";
import { Localization } from "../../common/Localization";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { Renderers } from "../../common/GridRowRenderer";
import { Button, DropDownButton, DropDownButtonItem } from "@progress/kendo-react-buttons";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import SpravaTextDialogContent from "../../dialogs/SpravaTextDialogContent";
import OdosielanieTovaruDialogContent from "../../dialogs/OdosielanieTovaruDialogContent";
import NahlasenieDodavkyDialogContent from "../../dialogs/NahlasenieDodavkyDialogContent";
import { animateScroll as scroll } from "react-scroll";
import { homeController } from "../../../controllers/home.controller";
import DialogWindow from "../../common/DialogWindow";
import { authenticationService } from "../../../services/authentication.service";
import confirmService from "../../common/confirmService";
import { LogLevel, MessageTypeEnum } from "../../../enums";
import { logController } from "../../../controllers/log.controller";

class SpravyDotaz extends Component {
    state = {
        items: [],
        selectedIdSprava: null,
        loading: true,
        dialog: {
            title: null,
            content: null,
            width: null,
            height: null
        }
    };

    componentDidMount() {
        this.reloadGrid();
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.shouldReloadGrid && this.props.shouldReloadGrid !== nextProps.shouldReloadGrid) {
            this.reloadGrid();
        }
        return true;
    }

    reloadGrid = () => {
        this.setState({ selectedIdSprava: null, loading: true });
        homeController
            .getSpravyDotaz()
            .then(ajaxData => {
                let data = JSON.parse(JSON.stringify(ajaxData), dateConvert);
                if (!data.isError) {
                    this.setState({ items: data, loading: false });
                    this.props.afterReload();
                } else {
                    logController.logMessage("SpravyDotaz.reloadGrid: " + data.errorMessage, LogLevel.Error);
                    this.setState({
                        errorMessage:
                            "Server vrátil chybu pri načítaní zoznamu. Chyba bola zaznamenaná do logu.\n\nSkúste prosím načítať zoznam znova pomocou tlačidla Aktualizovať.",
                        loading: false
                    });
                }
            })
            .then(() => {
                this.scrollToBottom();
            })
            .catch(error => {
                logController.logMessage("SpravyDotaz.reloadGrid: " + error, LogLevel.Error);
                this.setState({
                    errorMessage:
                        "Server vrátil chybu pri načítaní zoznamu. Chyba bola zaznamenaná do logu.\n\nSkúste prosím načítať zoznam znova pomocou tlačidla Aktualizovať.",
                    loading: false
                });
            });
    };

    gridRowEventHandler = (eventType, dataItem) => {
        var localizationService = provideLocalizationService(this);

        if (eventType === "onDoubleClick") {
            if (dataItem.textTypSpravy === "TEXT") {
                this.setState({
                    dialog: {
                        title: localizationService.toLanguageString("TexFRM.Textová správa", "Textová správa"),
                        content: () => <SpravaTextDialogContent selectedSpravaId={dataItem.idText} />
                    }
                });
            }

            if (dataItem.textTypSpravy === "EXPEDÍCIA") {
                this.setState({
                    dialog: {
                        title:
                            localizationService.toLanguageString("OdoFRM.Odosielanie tovaru z predajne", "Odosielanie tovaru z predajne") +
                            " " +
                            authenticationService.currentSkladNazov,
                        content: () => (
                            <OdosielanieTovaruDialogContent defaultExpediciaId={dataItem.idExpedicia} reloadOdoslanieGrids={this.props.reloadOdoslanieGrids} />
                        ),
                        height: "90%",
                        width: "90%"
                    }
                });
            }

            if (dataItem.textTypSpravy === "NAHLÁSENIE") {
                this.setState({
                    dialog: {
                        title: localizationService.toLanguageString("NahFRM.Nahlásenia dodávok tovaru", "Nahlásenia dodávok tovaru"),
                        content: () => (
                            <NahlasenieDodavkyDialogContent
                                selectedNahlasenieId={dataItem.idNahlasenie}
                                reloadNahlasenieGrids={this.props.reloadNahlasenieGrids}
                            />
                        ),
                        height: "90%",
                        width: "90%"
                    }
                });
            }
        }
    };

    scrollToBottom() {
        var divSpravyDotaz = document.getElementById("SpravyDotaz");
        if (divSpravyDotaz) {
            var container = divSpravyDotaz.getElementsByClassName("k-virtual-content");
            if (container) {
                scroll.scrollToBottom({
                    container: container[0]
                });
            }
        }
    }

    async handleMoznostiItemClick(event) {
        var localizationService = provideLocalizationService(this);

        switch (event.itemIndex) {
            case 0: // Znovu vytvoriť a odoslať správu
                if (!this.state.selectedIdSprava) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: "Zo zoznamu správ vyberte jednu správu, ktorú chcete znovu vygenerovat !"
                    });
                } else {
                    homeController.pregenerujeSpravu(this.state.selectedIdSprava).then(async response => {
                        if (response.errorMessage) {
                            await confirmService.show({
                                type: response.messageType,
                                message: response.errorMessage,
                                logMessage: true
                            });
                        }
                        this.reloadGrid();
                    });
                }
                break;
        }
    }

    renderTable(items) {
        var localizationService = provideLocalizationService(this);
        var renderers = new Renderers();

        var neodoslanych = 0;
        items.forEach(item => {
            if (item.datumOdoslania == null) neodoslanych++;
        });
        return (
            <div id="SpravyDotaz">
                <h2>
                    <Localization messageKey={"MenuFRM.SPRÁVY"} defaultMessage={"SPRÁVY"} /> ({neodoslanych}{" "}
                    <Localization messageKey={"MenuFRM.NEODOSLANÝCH"} defaultMessage={"NEODOSLANÝCH"} />)
                </h2>
                <div onMouseDown={e => e.preventDefault() /* prevents browser text selection */}>
                    <Grid
                        data={items.map(item => ({ ...item, selected: item.idsprava === this.state.selectedIdSprava }))}
                        selectedField="selected"
                        onRowClick={e => {
                            this.setState({ selectedIdSprava: e.dataItem.idsprava });
                        }}
                        rowRender={(trElement, dataItem) => renderers.rowRender(trElement, dataItem, this.gridRowEventHandler)}>
                        <GridColumn field="idSprava2" title={localizationService.toLanguageString("SpravyDotaz.Grid.ID", "ID")} width="48px" />
                        <GridColumn
                            field="textTypSpravy"
                            title={localizationService.toLanguageString("SpravyDotaz.Grid.Typ správy", "Typ správy")}
                            width="85px"
                        />
                        <GridColumn field="popis" title={localizationService.toLanguageString("SpravyDotaz.Grid.Popis", "Popis")} />
                        <GridColumn
                            field="datumVytvorenia"
                            title={localizationService.toLanguageString("SpravyDotaz.Grid.Vytvorená", "Vytvorená")}
                            format="{0:d.M.yyyy}"
                            width="70px"
                        />
                        <GridColumn
                            field="vytvorilUzivatelMeno"
                            title={localizationService.toLanguageString("SpravyDotaz.Grid.Vytvoril", "Vytvoril")}
                            width="60px"
                        />
                        <GridColumn
                            field="datumOdoslania"
                            title={localizationService.toLanguageString("SpravyDotaz.Grid.Odoslaná", "Odoslaná")}
                            format="{0:d.M. H:mm}"
                            width="80px"
                        />
                    </Grid>
                </div>
                <div className="grid-button-bar">
                    <div className="col-sm-6">
                        <Button icon="refresh" onClick={() => this.props.reloadHomePageGrids()}>
                            <Localization messageKey={"MenuFRM.Aktualizovať"} defaultMessage={"Aktualizovať"} />
                        </Button>
                    </div>
                    <div className="col-sm-6 text-right">
                        <DropDownButton
                            text={localizationService.toLanguageString("MenuFRM.Možnosti", "Možnosti")}
                            icon="menu"
                            onItemClick={e => this.handleMoznostiItemClick(e)}>
                            <DropDownButtonItem
                                text={localizationService.toLanguageString("Menu.Znovu vytvoriť a odoslať správu", "Znovu vytvoriť a odoslať správu")}
                            />
                        </DropDownButton>
                    </div>
                </div>
            </div>
        );
    }

    renderError(errorMessage) {
        return (
            <div id="NahlasenieNenahlaseneDodavky">
                <h2>
                    <Localization messageKey={"MenuFRM.SPRÁVY"} defaultMessage={"SPRÁVY"} />
                </h2>
                <div className="alert alert-danger">{errorMessage}</div>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? (
            <LoadingPanel />
        ) : this.state.errorMessage ? (
            this.renderError(this.state.errorMessage)
        ) : (
            this.renderTable(this.state.items)
        );

        return (
            <div>
                {contents}
                <DialogWindow dialog={this.state.dialog} />
            </div>
        );
    }
}

export default SpravyDotaz;

registerForLocalization(SpravyDotaz);



// WEBPACK FOOTER //
// ./src/components/views/Home/SpravyDotaz.js